import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const tmCalculatorTool: Tool = {
  id: "tm-calculator",
  name: () => m.tm_tool_name(),
  description: () => m.tm_tool_description(),
  icon: "🌡️",
  basePath: "/tm-calculator",
  status: "stable",
  tags: [
    "bioinformatics",
    "pcr",
    "primer",
    "science",
    "melting-temperature",
    "oligo",
  ],
};
